/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

export const DRIVER_SESSION = "session";
export const COGNITO_CLIENT_ID = "client";

export const ACCESS_TOKEN = "AccessToken";
export const ID_TOKEN = "IdToken";
export const REFRESH_TOKEN = "RefreshToken";
